import Mine from "./item/mine"
import Exam from './item/exam'
import Class from './item/class'

export default {
  Mine,Exam,Class
};
